export default (value: string) => parseInt(value, 10);
